import axios from 'axios'

const API_URL = '/api/images/'

// Get Flooring
const getFlooring = async () => {
	const response = await axios.get(API_URL + 'getFlooring')

	if (response.data) {
	}

	return response.data
}

const flooringService = { getFlooring }

export default flooringService
